module.exports = __webpack_public_path__ + "static/media/royal.d6de84ee.png";